<template>
  <Button
    :disabled="disabled"
    :severity="severity"
    :variant="variant"
    :size="resolvedSize"
    :class="{ 'p-button-icon-only': iconOnly }"
    @click="!loading && $emit('click', $event)"
  >
    <RriIcon
      v-if="resolvedLeftIcon"
      :icon="resolvedLeftIcon"
      :size="size === 'small' ? 'sm' : 'md'"
      class="p-button-icon"
    />
    <span
      v-if="!iconOnly"
      class="p-button-label"
    >
      {{ label }}
    </span>
    <RriIcon
      v-if="rightIcon"
      :icon="rightIcon"
      :size="size === 'small' ? 'sm' : 'md'"
      class="p-button-icon"
    />
  </Button>
</template>

<script setup>
import { computed } from 'vue'
import Button from 'primevue/button'
import RriIcon from '@/components/rri/RriIcon.vue'

const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  variant: {
    type: String,
    default: 'primary',
    validator: value => ['primary', 'outlined', 'link'].includes(value)
  },
  severity: {
    type: String,
    default: 'primary',
    validator: value =>
      ['primary', 'secondary', 'success', 'danger', 'contrast'].includes(value)
  },
  size: {
    type: String,
    default: 'small',
    validator: value => ['small', 'medium', 'large'].includes(value)
  },
  disabled: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  leftIcon: {
    type: String,
    default: ''
  },
  rightIcon: {
    type: String,
    default: ''
  },
  iconOnly: {
    type: Boolean,
    default: false
  }
})

defineEmits(['click'])

const resolvedLeftIcon = computed(() => (props.loading ? 'loader' : props.leftIcon))
// 'medium' maps to no size in PrimeVue (uses default padding: 8px 16px)
const resolvedSize = computed(() => (props.size === 'medium' ? undefined : props.size))
</script>
